import React from "react";
import { useSelector } from "react-redux";
import Tabs from "../portrait/Tabs";
import NumberKeyset from "./NumberKeyset";
import AlphabetKeyset from "./AlphabetKeyset";

const Landscape = ( props ) => {

  const keypad = useSelector( state => state.keypad );

  const {
    children,
    ...PROPS
  } = props;

  return (
    <div className="keypad_gm middle tab-wrap hide_tv hide_m">
      <div className="upper_area">
        <Tabs { ...PROPS } />
      </div>
      <div className="mid_area">
        { '0' === keypad.tabIndex ? <NumberKeyset { ...PROPS } /> : <AlphabetKeyset { ...PROPS } /> }
      </div>
      <div className="lower_area">{ props.children }</div>
    </div>
  );

};

export default Landscape;
